var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"content-pane"}},[_c('div',[_c(_vm.component,{tag:"component"}),_c('copyright')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }